import React from "react"
import { connect } from "react-redux"
import {
  setFollowUpText,
  submitFollowUp,
  submitFollowUpText,
  showPostIntentPopUp,
  getFollowUpOptions,
} from "../../actions"
import { startSectionTracker, endSectionTracker } from "../../../completion/actions"
import { Waypoint } from "react-waypoint"
import { setSearchActive, specialistInfoSubmit } from "../../../search/actions"
import { SOMETHING_ELSE, UNSURE, OTHER } from "../../constants"
import { setSpecialist } from "../../../integration/actions"
import tracker from "../../../common/tracker"
import SpecialistSearch from "./components/SpecialistSearch"
import PostIntentOptions from "./components/PostIntentOptions"
import PopUpContainer from "./components/PopUpContainer"
import InnerContainer from "./components/InnerContainer"

const PostIntent = props => (
  <PopUpContainer
    response={props.response === SOMETHING_ELSE || props.response === UNSURE}
  >
    <Waypoint 
      onEnter={startSectionTracker('post intent feedback')}
      onLeave={endSectionTracker('post intent feedback')}
    >
      <InnerContainer>
        {props.specialistSearch ? (
          <SpecialistSearch {...props} />
        ) : (
          <PostIntentOptions {...props} />
        )}
      </InnerContainer>
    </Waypoint>
  </PopUpContainer>
)
const mapStateToProps = state => ({
  response: state.feedback.followUp.response,
  text: state.feedback.followUp.text,
  submitted: state.feedback.followUp.submitted,
  show: state.feedback.showPostIntentPopUp,
  options: state.feedback.followUp.options,
  specialistOptions: state.feedback.followUp.specialistOptions,
  specialist: state.integration.specialist.display,
  specialistSuggestion: state.feedback.followUp.specialistSuggestion,
})

const mapDispatchToProps = dispatch => ({
  getFollowUpOptions: () => dispatch(getFollowUpOptions()),
  submitFollowUp: option => () => {
    dispatch(submitFollowUp(option))
    if (option !== SOMETHING_ELSE && option !== UNSURE) {
      tracker.postIntentPopUpResponse(option, false)
    }
  },
  setText: e => dispatch(setFollowUpText(e.target.value)),
  submitFollowUpText: (selection, comment) => () => {
    dispatch(submitFollowUpText())
    comment
      ? tracker.postIntentPopUpResponse(selection, true)
      : tracker.postIntentPopUpResponse(selection, false)
  },
  showPopUp: e => () => dispatch(showPostIntentPopUp(e)),
  setSearchActive: state => {
    dispatch(setSearchActive(state))
  },
  onSubmitSpecialistSuggestion: () => {
    dispatch(specialistInfoSubmit(true, true))
  },
  setSpecialist: specialist => () => {
    dispatch(setSpecialist(specialist))
    if (specialist !== OTHER) {
      dispatch(specialistInfoSubmit(true, true))
    }
  },
})

class PostIntentContainer extends React.Component {
  constructor() {
    super()
    this.state = {
      specialistSearch: false,
      postIntent: {
        header: "Help Buoy get smarter",
        timeout: 7000,
      },
    }

    this.handleSpecialistSearch = this.handleSpecialistSearch.bind(this)
  }

  componentDidMount() {
    if (this.props.options.length === 0) {
      this.props.getFollowUpOptions()
    }
  }

  handleSpecialistSearch = () => () => {
    const { specialistSearch } = this.state
    this.setState({ specialistSearch: !specialistSearch })
  }

  render() {
    const { show } = this.props
    return show ? (
      <PostIntent
        {...this.props}
        {...this.state}
        handleSpecialistSearch={this.handleSpecialistSearch}
      />
    ) : null
  }
}

const ConnectedPostIntentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PostIntentContainer)
export { ConnectedPostIntentContainer as default, PostIntent }



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/index.js